
import Layout from '../views/layout/App.vue'

export default     {
    path: '/teachMarkManage',
    name: 'TeachMarkManage',
    meta: {
        title: '教研标记管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/teachMarkManage',
    children: [
        {
            path: 'firstTagList',
            name: 'FirstTagList',
            meta: {
                title: '一级标记列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/teachMarkManage/firstTagList/Index.vue'], resolve),
        },
        {
            path: 'secondTagList',
            name: 'SecondTagList',
            meta: {
                title: '二级标记列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/teachMarkManage/secondTagList/Index.vue'], resolve),
        },
        {
            path: 'threeTagList',
            name: 'ThreeTagList',
            meta: {
                title: '三级标记列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/teachMarkManage/threeTagList/Index.vue'], resolve),
        },
    ]
}


